import { render } from "./add-note.vue?vue&type=template&id=47a02af4&scoped=true"
import script from "./add-note.vue?vue&type=script&lang=js"
export * from "./add-note.vue?vue&type=script&lang=js"

import "./add-note.vue?vue&type=style&index=0&id=47a02af4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1381316803/src/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a02af4"]])

export default __exports__